(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const components = document.querySelectorAll('collection-component');
      if (!components.length) return;

      const findHeadingSection = (component) => {
        const title = document.querySelector('h1');
        if (!title) return null;

        const section = title.closest('.shopify-section, section, .section');
        if (!section || component.contains(section)) return null;

        return section;
      };

      components.forEach((component) => {
        const resultsList = component.querySelector('results-list');
        if (!resultsList) return;

        const inlineIntro = component.querySelector('.ms-content-intro');
        const fallbackDetails = component.querySelector('.ms-collection-details');

        if (inlineIntro) {
          resultsList.insertAdjacentElement('afterend', inlineIntro);
          inlineIntro.classList.add('ms-content-intro--after-grid');

          if (fallbackDetails) {
            fallbackDetails.hidden = true;
          }
        }

        const headingSection = findHeadingSection(component);
        if (!headingSection) return;

        headingSection.querySelectorAll('rte-formatter, .text-block.rte').forEach((block) => {
          if (block.querySelector('h1, h2, h3, h4, h5, h6, [role="heading"]')) return;
          if (!block.textContent.trim()) return;

          block.hidden = true;
          block.setAttribute('aria-hidden', 'true');
        });
      });
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
